<template>
    <div>
        <b-card>
            <template slot="header">
                <b-row>
                    <b-col cols="9" sm="7" md="6" lg="6" xl="5"></b-col>
                    <b-col cols="9" sm="7" md="6" lg="6" xl="5">
                        <h3>Lista de Vehiculos</h3>
                    </b-col>
                </b-row>
            </template>
            <b-row>
                <b-col cols="2" sm="3" md="4" lg="4" xl="7">
                    <b-button
                    variant="primary"
                    @click="abrirModalVehiculos()">
                    Vehiculo |
                    <i class="fa fa-car" aria-hidden="true"></i>
                    <i class="fa fa-plus ml-2" aria-hidden="true"></i>
                    </b-button>
                </b-col>
                <b-col cols="2" sm="3" md="4" lg="4" xl="2">
                    <b-form-group horizontal label="Orden">
                    <b-input-group>
                        <b-form-select v-model="orden" slot="append" @input="listarVehiculos">
                            <option :value="'asc'">Más Antiguo</option>
                            <option :value="'desc'">Más Reciente</option>
                        </b-form-select>
                    </b-input-group>
                </b-form-group>
                </b-col>
                <b-col cols="12" sm="10" md="10" lg="10" xl="2">
                    <b-form-group horizontal label="Mostrar">
                        <b-input-group>
                        <b-form-select v-model="limite" slot="append">
                            <option :value="10">10</option>
                            <option :value="25">25</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </b-form-select>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="2" sm="3" md="4" lg="4" xl="1">
                    <b-button
                    v-b-tooltip.hover="'Actualizar'"
                    @click="listarVehiculos()">
                    <i class="fa fa-sync-alt"></i>
                    </b-button>
                </b-col>
                <b-modal v-model="modalAddVehiculo" size="xl">
                    <template slot="modal-title">
                        <h3>Agregar Vehículo <i class="fa fa-car fa-lg" aria-hidden="true"></i></h3>
                    </template>
                    <b-row>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-select 
                                v-model="tipoVehiculo" 
                                :options="optionsVehiculo">
                            </b-select>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-input 
                                v-model="codigo"
                                placeholder="Alias"
                                type="text"
                                maxlength="15">
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-select 
                                v-model="propiedad" 
                                :options="optionsPropiedad">
                            </b-select>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-group
                                :state="stateCirculacionVehiculoPlaca"
                                :invalid-feedback="invalidFeedbackCirculacionVehiculoPlaca">
                            <b-input-group>
                                <b-form-input
                                    :state="stateCirculacionVehiculoPlaca"
                                    v-model="placa"
                                    placeholder="Placa"
                                    type="text"
                                    @input="mayus()"
                                    @keydown="validaSoloAlfaNum"
                                    maxlength="7">
                                </b-form-input>
                                <b-input-group-text slot="append">
                                    <b-button 
                                    disabled
                                    variant="primary"
                                    class="pb-0 pt-0 pl-1 pr-1"
                                    size="sm">
                                    ABC123
                                    </b-button>
                                </b-input-group-text>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-input
                                v-model="marca"
                                placeholder="Marca"
                                type="text">
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-input
                                v-model="categoriaMtc"
                                placeholder="Categoría MTC"
                                @input="mayus()"
                                type="text"
                                @keydown="handleKeyDown"
                                maxlength="8">
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-group
                            :state="stateCirculacionMtc"
                            :invalid-feedback="invalidFeedbackCirculacionMtc"
                            :valid-feedback="validFeedbackCirculacionMtc">
                                <b-form-input
                                    :state="stateCirculacionMtc"
                                    v-model="nroCirculacionMtc"
                                    placeholder="Certificado de Habilitación Vehicular - TUCE"
                                    type="text"
                                    @input="mayus()"
                                    @keydown="handleKeyDown"
                                    maxlength="40">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                           <b-form-input
                                v-model="anioFabricacion"
                                placeholder="Año Fabricación"
                                type="number"
                                maxlength="4">
                            </b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-input
                                v-model="maximoTripulacion"
                                placeholder="Cantidad Pasajeros"
                                type="number">
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-input
                                v-model="pesoBruto"
                                placeholder="Peso Bruto"
                                type="number">
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-input
                                v-model="cargaUtil"
                                placeholder="Carga Útil"
                                type="number">
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <select class="form-control input-placedark input-dark" 
                                v-model="indexEntidadEmisora">
                            <option
                                v-for="(entidad, index) in infoEntidadEmisora"
                                :value="index"
                                :key="index"
                            >{{ entidad.nombre }}</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-form-input
                                :disabled="indexEntidadEmisora == 0"
                                placeholder="Nro. Autorización emitido por la entidad"
                                 @keydown="handleKeyDown"
                                 @input="mayus()"
                                v-model="numeroPermiso">
                            </b-form-input>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <select class="custom-select mr-sm-2 input-placedark input-dark colorBorde" id="inlineFormCustomSelect" v-model="tipoDocumento">                       
                                <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                                {{ tipodocumento.nombre }}
                                </option>
                            </select>
                        </b-col>
                        <b-col  cols="12" sm="6" md="4" lg="4" xl="3">
                            <b-form-input
                                    class="input-placedark input-dark colorBorde"
                                    placeholder="Buscar..."
                                    maxlength="11"
                                    v-model="receptor.numero"
                                    @change="getReceivers()"
                            ></b-form-input>
                            <template v-if="cargandoreceptor">
                                <b-list-group class="searcher-field">
                                <b-list-group-item>
                                    Buscando
                                    <i class="fa fa-spin fa-spinner"></i>
                                </b-list-group-item>
                                </b-list-group>
                            </template>
                            <b-list-group v-if="listarec" class="searcher-field">
                                <!-- <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item> -->
                                <template v-for="(item, index) in listaReceptores">
                                <b-list-group-item
                                        :key="index"
                                        @click="setReceiver(item)"
                                        class="searcher-result"
                                >{{item.idReceptor + ' - ' + item.razonSocial}}</b-list-group-item>
                                </template>
                            </b-list-group>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                            <b-button v-if="!mostrarBotonEdicion"
                                :disabled="validarVehiculo()"
                                style="width:100%"
                                variant="primary"
                                @click="AddVehiculo()">
                                Agregar
                                
                            </b-button>
                            <b-button v-else
                                :disabled="validarVehiculo()"
                                style="width:100%"
                                variant="warning"
                                @click="enviarEdicionVehiculo()">
                                Editar
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                         <b-col cols="12" sm="8" md="6" lg="6" xl="6">
                            <b-form-textarea
                            v-model="observaciones"
                            placeholder="Ingresar Observaciones..."
                            maxlength="100"
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                         </b-col>
                    </b-row>
                    <template slot="modal-footer">
                       <b-button
                        variant="secondary"
                        @click="cerrarModal()">
                            Cerrar
                       </b-button>
                    </template>
                </b-modal>
            </b-row>
            <b-row class="mt-3">
                <b-col cols="9" sm="7" md="6" lg="6" xl="12">
                    <template v-if="mostrarTabla">
                        <div class="text-center">
                            <h2><i class="fa fa-spin fa-spinner"></i> Cargando...</h2>
                        </div>
                    </template>
                    <template v-else>
                        <b-table
                            striped
                            bordered
                            small
                            hover
                            responsive
                            outlined
                            :per-page="limite"
                            :items="vehiculos"
                            :fields="vehiculos_lista">
                            <template slot="index" slot-scope="row"><b>{{ row.index+1 }}</b></template>
                            <template slot="categoriaMtc" slot-scope="row">
                                {{row.item.CategoriaMTC}}
                            </template>
                            <template slot="nroCirculacionMtc" slot-scope="row">
                                {{row.item.nroCirculacionMTC}}
                            </template>
                             <template slot="anioFabricacion" slot-scope="row">
                                <div class="text-center">{{row.item.anioFabricacion}}</div>
                            </template>
                             <template slot="maximoTripulacion" slot-scope="row">
                                <div class="text-center">{{row.item.maximoTripulacion}}</div>
                            </template>
                            <template slot="eliminarEditar" slot-scope="row">
                                <b-button-group>
                                <b-button v-if="row.item.driver.length >0"
                                    @click="row.toggleDetails"
                                    variant="primary"
                                    class="btn btn-sm" 
                                    v-b-tooltip.hover="'Ver Conductor Asociado'">
                                    <template v-if="!row.detailsShowing">
                                       <i class="fa fa-id-card fa-lg" aria-hidden="true"></i>
                                    </template>
                                    <template v-else>
                                        <i class="fa fa-minus"></i>
                                     </template>
                                </b-button>
                                <b-button 
                                    v-b-tooltip.hover="'Editar'"
                                    size="sm"
                                    variant="warning"
                                    @click="capturaInfoEdicionVihiculo(row.item)">
                                    <i class="fa fa-edit" aria-hidden="true"></i>
                                </b-button>
                                <b-button
                                    v-b-tooltip.hover="'Eliminar'"
                                    size="sm"
                                    variant="danger"
                                    @click="eliminarVehiculo(row.item)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </b-button>
                                </b-button-group>
                            </template>
                            <template slot="row-details" slot-scope="row">
                               <b-card>
                                <div class="p-1">
                                 <b-table 
                                    head-variant="light" 
                                    :items="row.item.driver"
                                    :fields="conductores_lista"
                                    outlined>
                                    <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                                    <template slot="tipoDocumento" slot-scope="row">
                                        <div v-if="row.item.tipoDocumento == 6">RUC</div>
                                        <div v-if="row.item.tipoDocumento == 1">DNI</div>
                                        <div v-if="row.item.tipoDocumento == 4">Carnet Extranjeria</div>
                                        <div v-if="row.item.tipoDocumento == 7">Pasaporte</div>
                                    </template>
                                </b-table> 
                                </div> 
                               </b-card>
                            </template>
                        </b-table>
                        <b-row>
                            <b-col cols="9" sm="7" md="6" lg="6" xl="6">
                                <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                            </b-col>
                            <b-col cols="9" sm="7" md="6" lg="6" xl="6">
                                <div class="float-right">
                                <b-pagination
                                    :total-rows="total"
                                    v-model="paginaActual"
                                    @input="listarVehiculos"
                                    :per-page="limite"
                                ></b-pagination>
                                </div>
                            </b-col>
                        </b-row>
                    </template>
                </b-col>
            </b-row>
            
       </b-card>
       <vue-snotify></vue-snotify>
    </div>
</template>
<script>
  import axios from "axios";
  import { entidadEmisora } from "@/shared/utils";
  import { DocumentosIdentidad } from '@/shared/utils';

export default {
    name:  "Negocios_Vehiculos",
    components:{

    },
    data() {
        return {
            infoEntidadEmisora:entidadEmisora,
            indexEntidadEmisora:0,
            numeroPermiso:'',
            modalAddVehiculo:false,
            mostrarTabla: true,
            tipoVehiculo:0,
            optionsVehiculo:[
                { value:0, text:'Seleccionar Vehículo'},
                { value:'Camión', text:'Camión'},
                { value:'Auto', text:'Auto'},
                { value:'Carreta', text:'Carreta'},
                { value:'Bus', text:'Bus'},
                { value:'Moto', text:'Moto'},  
            ],      
            codigo:"",
            propiedad:0,
            optionsPropiedad:[
                { value:0, text:'Seleccionar Propiedad'},
                { value:'Propio', text:'Propio'},
                { value:'Externo', text:'Externo'}, 
            ],
            placa:'',
            marca:'',
            categoriaMtc:'',
            nroCirculacionMtc:'',
            anioFabricacion:'',
            maximoTripulacion:'',
            pesoBruto:'',
            cargaUtil:'',
            observaciones:'',
            vehiculos:[],
            vehiculos_lista:[
               { key: "index", label: "Nro."},
               { key: "tipoVehiculo", label: "Vehículo"},
               { key: "codigo", label: "Código"},
               { key: "propiedad", label: "Propiedad"},
               { key: "placa", label: "Placa"},
               { key: "marca", label: "Marca"},
               { key: "categoriaMtc", label: "Categoría MTC"},
               { key: "nroCirculacionMtc", label: "Circulación MTC"},
               { key: "anioFabricacion", label: "Año Fabricación"},
               { key: "maximoTripulacion", label: "Cant. Pasajeros"},
               { key: "pesoBruto", label: "Peso Bruto"},
               { key: "cargaUtil", label: "Carga Útil"},
               { key: "observaciones", label: "Observaciones"},
               { key: "eliminarEditar", label: "Acciones"},
            ],
            conductores_lista:[
               { key: "tipoDocumento", label: "Tipo Doc."},
               { key: "nroDocumento", label: "Num. Documento"},
               { key: "codigo", label: "Código"},
               { key: "nombres", label: "Nombres"},
               { key: "apellidos", label: "Apellidos"},
               { key: "direccion", label: "Dirección"},
               { key: "fechaNacimiento", label: "Fec. Nacimiento"},
               { key: "nroLicencia", label: "Nro. Licencia"},
               { key: "catLicencia", label: "Cat. Licencia"},
               { key: "vencLicencia", label: "Vencimiento Licencia"},
               { key: "observaciones", label: "Observaciones"},
            ],
            idVehiculo:'',
            mostrarBotonEdicion:false,
            total: 0.0,
            desde: 0.0,
            hasta: 0.0,
            paginaActual: 1,
            limite:10,
            codigoEntidad:'',
            receptor: {
                tipo:'',
                numero:'',
                razonSocial:'',
                direccion:''                               
            },
            documentosIdentidad: DocumentosIdentidad,
            tipoDocumento:6,
            cargandoreceptor: false,
            listarec: true,
            formadepago: {
                codigo: '008',
                nombre: "Efectivo ventas menores"
            },
            listaReceptores:[],
            orden: "desc",
        }
    },
    mounted(){
        this.listarVehiculos();
    },
    computed:{
        stateCirculacionVehiculoPlaca () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.placa.length == 0){

            } else if (this.placa.length < 6)  {
                return false
            } else if(this.placa.length == 7 ){
                return true
            }
        },
        invalidFeedbackCirculacionVehiculoPlaca() {
            // let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.placa.length == 1) {
                return 'Ingresar mínimo 6 y máximo 7'
            } else {
                return 'Ingresar mínimo 6 valores '
            }
        },
        stateCirculacionMtc () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.nroCirculacionMtc.length == 0){

            } else if (this.nroCirculacionMtc.length < 10)  {
                return false
            } else if(this.nroCirculacionMtc.length == 40 ){
                return true
            }
        },
       invalidFeedbackCirculacionMtc () {
            // let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.nroCirculacionMtc.length == 1) {
                return 'Ingresar mínimo 10 valores'
            } else {
                return 'Ingresar mínimo 10 valores '
            }
        },
        validFeedbackCirculacionMtc () {
        // return this.stateCirculacionMtc === true ? 'Perfecto' : ''
        },
    },
    watch:{
        indexEntidadEmisora(value){
            this.codigoEntidad = this.infoEntidadEmisora[value].codigo
        },
    },
    methods:{
        abrirModalVehiculos(){
            this.modalAddVehiculo = true;
            this.mostrarBotonEdicion = false;
            this.limpiarDatos();
        },
        cerrarModal(){
            this.modalAddVehiculo = false; 
        },
        validarVehiculo(){
            if(this.tipoVehiculo !=0 && this.propiedad !=0 &&
               this.codigo !='' && 
               this.placa.length >5 && 
               this.marca !='' &&
               this.categoriaMtc !='' &&
               this.anioFabricacion !='' &&
               this.maximoTripulacion !='' &&
               this.pesoBruto !='' &&
               this.cargaUtil !='' &&
               this.indexEntidadEmisora != 0 &&
               this.numeroPermiso != ''){
                return false;
            }else{
                return true;
            }
        },
        AddVehiculo(){
            let send = {}
            send.token = this.$store.getters.userToken,
            send.tipoVehiculo = this.tipoVehiculo,
            send.codigo = this.codigo,
            send.propiedad = this.propiedad,
            send.placa = this.placa,
            send.marca = this.marca,
            send.CategoriaMTC = this.categoriaMtc,
            send.nroCirculacionMTC = this.nroCirculacionMtc,
            send.anioFabricacion = this.anioFabricacion,
            send.maximoTripulacion = this.maximoTripulacion,
            send.pesoBruto = this.pesoBruto,
            send.cargaUtil = this.cargaUtil,
            send.idEntidad = this.codigoEntidad,
            send.numeroPermiso = this.numeroPermiso,
            send.observaciones = this.observaciones;
            send.tipoDocumento = this.tipoDocumento;
            send.numeroDocumento = this.receptor.numero;

            axios.post(process.env.VUE_APP_API_URL + "vehiculos/crear",send)
            .then(response =>(
                 this.$snotify.success(response.data.msg, "Exito"),
                 this.limpiarDatos(),
                 this.modalAddVehiculo = false,
                 this.listarVehiculos()
            ))
            .catch(error =>(
                this.$snotify.warning(error.response.data.msg, "Error")
            ))
        },
        limpiarDatos(){
            this.tipoDocumento = 6,
            this.receptor.numero = '',
            this.formadepago.codigo = '008',
            this.tipoVehiculo = 0, 
            this.propiedad = 0,
            this.codigo = '',
            this.placa = '',
            this.marca = '',
            this.categoriaMtc = '',
            this.nroCirculacionMtc = '',
            this.anioFabricacion = '',
            this.maximoTripulacion = '',
            this.pesoBruto = '',
            this.cargaUtil = '',
            this.observaciones = ''
            this.indexEntidadEmisora = 0,
            this.numeroPermiso = ''
        },
        listarVehiculos(){
            this.mostrarTabla = true;
            axios.post(process.env.VUE_APP_API_URL + "vehiculos/listar",{
                token:this.$store.getters.userToken,
                page: this.paginaActual,
                limit: this.limite,
                order: this.orden
            })
            .then(response =>(
                this.vehiculos = response.data.data,
                this.mostrarTabla = false,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to
            ))
            .catch(error=>(
                console.log('ERROR LISTA INFORMACION',error.response.data)
            ))
        },
        capturaInfoEdicionVihiculo(item){
            this.idVehiculo = item.idVehiculo
            this.modalAddVehiculo = true;
            this.tipoVehiculo = item.tipoVehiculo, 
            this.propiedad = item.propiedad,
            this.codigo = item.codigo,
            this.placa = item.placa,
            this.marca = item.marca,
            this.categoriaMtc = item.CategoriaMTC,
            this.nroCirculacionMtc = item.nroCirculacionMTC,
            this.anioFabricacion = item.anioFabricacion,
            this.maximoTripulacion = item.maximoTripulacion,
            this.pesoBruto = item.pesoBruto,
            this.cargaUtil = item.cargaUtil,
            this.indexEntidadEmisora = item.idEntidad,
            this.numeroPermiso = item.numeroPermiso,
            this.observaciones = item.observaciones
            this.mostrarBotonEdicion = true;
        },
        enviarEdicionVehiculo(){
            let nuevaInfo ={}
            nuevaInfo.token = this.$store.getters.userToken,
            nuevaInfo.idVehiculo = this.idVehiculo,
            nuevaInfo.tipoVehiculo = this.tipoVehiculo, 
            nuevaInfo.propiedad = this.propiedad,
            nuevaInfo.codigo = this.codigo,
            nuevaInfo.placa = this.placa,
            nuevaInfo.marca = this.marca,
            nuevaInfo.CategoriaMTC = this.categoriaMtc,
            nuevaInfo.nroCirculacionMTC = this.nroCirculacionMtc,
            nuevaInfo.anioFabricacion = this.anioFabricacion,
            nuevaInfo.maximoTripulacion = this.maximoTripulacion,
            nuevaInfo.pesoBruto = this.pesoBruto,
            nuevaInfo.cargaUtil = this.cargaUtil,
            nuevaInfo.idEntidad = this.codigoEntidad,
            nuevaInfo.numeroPermiso = this.numeroPermiso,
            nuevaInfo.observaciones = this.observaciones

            axios.post(process.env.VUE_APP_API_URL + "vehiculos/actualizar",nuevaInfo)
            .then(response =>(
                this.$snotify.success(response.data.msg, "Exito"),
                this.modalAddVehiculo = false,
                this.mostrarBotonEdicion = false,
                this.listarVehiculos()
            ))
            .catch(error=>(
                console.log(error.response.data)
            ))
        },
        eliminarVehiculo(item){
            this.$swal({
            title: 'Eliminar Vehículo',
            text: '¿Seguro que desea eliminar el Vehículo?',
            icon: 'warning',
            buttons: true,
            dangerMode: true
            }).then((willDelete) => {
            if(willDelete){
                axios.post(process.env.VUE_APP_API_URL + "vehiculos/borrar",{
                    token: this.$store.getters.userToken,
                    idVehiculo: item.idVehiculo
                })
                .then(response =>(
                    this.$snotify.success(response.data.msg, "Exito"),
                    this.listarVehiculos()
                ))
                .catch(error=>(
                    console.log(error.response.data)
                )) 
            }
            })
             
        },
        mayus(){
            this.placa = this.placa.toUpperCase();
            this.categoriaMtc = this.categoriaMtc.toUpperCase();
            this.numeroPermiso = this.numeroPermiso.toUpperCase();
            this.nroCirculacionMtc = this.nroCirculacionMtc.toUpperCase();
        },
        validaSoloAlfaNum(event) {
            const regex = /^[a-zA-Z0-9]+$/; 
             if (!regex.test(event.key)) {
                event.preventDefault();
            }
        },
        handleKeyDown(event) {
             // Expresión regular que identifica los caracteres especiales
            const regex = /^[a-zA-Z0-9]+$/; 
            // Verifica si el carácter presionado es un carácter especial
             if (!regex.test(event.key)) {
                // Si es un carácter especial, evita el evento keydown
                event.preventDefault();
            }
        },
        getReceivers: function () {
           if(this.receptor.numero.length>3){
               this.cargandoreceptor = true
               this.listarec = false
               this.norec = false
               axios
                .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                    token: this.$store.getters.userToken,
                    q: this.receptor.numero,
                    tipoRec: this.tipoDocumento
                })
                .then(response => (
                    this.listaReceptores = response.data,
                    this.cargandoreceptor = false,
                    this.listarec = true,
                    this.receivercount(this.listaReceptores.length)                                 
                ))
                .catch(function (error){
                    this.cargandoreceptor = false
                    this.listarec = false
                })
            }            
        },
        setReceiver: function(item) {
            (this.receptor.numero = item.idReceptor),
            (this.listarec = false),
            (this.listaReceptores = []);
        },
    }

}
</script>
<style scoped>

</style>